module.exports = __webpack_public_path__ + "static/media/white-arrow.e0e66f0a.svg";